module.exports = __webpack_public_path__ + "static/media/noPhoto.1323a2a5.png";